import { request } from './api';

// Returned by /auth/login and /auth/register. `method` drives the "code sent to your phone/email" copy.
export interface OtpChallenge {
  method: 'email' | 'phone';
}

// Returned on success by /auth/verify-otp and /auth/register/verify — backend sets __Host-session.
export interface AuthStatus {
  status: 'authenticated';
}

export const authApi = {
  login: (identifier: string): Promise<OtpChallenge> =>
    request<OtpChallenge>('/auth/login', { method: 'POST', body: { identifier } }),

  verifyOtp: (identifier: string, code: string, clientId?: string): Promise<AuthStatus> =>
    request<AuthStatus>('/auth/verify-otp', {
      method: 'POST',
      body: { identifier, code, ...(clientId ? { client_id: clientId } : {}) },
    }),

  register: (identifier: string): Promise<OtpChallenge> =>
    request<OtpChallenge>('/auth/register', { method: 'POST', body: { identifier } }),

  registerVerify: (identifier: string, code: string, name: string, clientId?: string): Promise<AuthStatus> =>
    request<AuthStatus>('/auth/register/verify', {
      method: 'POST',
      body: { identifier, code, name, ...(clientId ? { client_id: clientId } : {}) },
    }),
};

